/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type createJiraIssueModal_viewer = {
    readonly id: string;
    readonly project: {
        readonly id: string;
        readonly jiraSubtaskType: string | null;
        readonly jiraCloudProject: {
            readonly id: string;
        } | null;
        readonly jiraCloudProjectSettings: {
            readonly id: string;
            readonly mapJiraEpicToPhase: boolean | null;
        } | null;
        readonly jiraServerProject: {
            readonly id: string;
        } | null;
        readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
    } | null;
    readonly " $refType": "createJiraIssueModal_viewer";
};
export type createJiraIssueModal_viewer$data = createJiraIssueModal_viewer;
export type createJiraIssueModal_viewer$key = {
    readonly " $data"?: createJiraIssueModal_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"createJiraIssueModal_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "createJiraIssueModal_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraSubtaskType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraCloudProjectType",
          "kind": "LinkedField",
          "name": "jiraCloudProject",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraCloudProjectSettingsType",
          "kind": "LinkedField",
          "name": "jiraCloudProjectSettings",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mapJiraEpicToPhase",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraServerProjectType",
          "kind": "LinkedField",
          "name": "jiraServerProject",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraCloudEpicIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '3221a3be3c01954349b33977f1ec7562';
export default node;
